 jQuery(document).ready(function($){
     if($(window).width()>769){
        if($('body').hasClass('cstm__product') && $('label').hasClass('color__label')){
         function mainthumbslider(){
         $('.thumb_main').slick({
      dots: false,
      arrow: true,
      vertical: true,
      nextArrow: '<button type="button" class="slick-next"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
      prevArrow: '<button type="button" class="slick-prev"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path></svg></button>',
      slidesToShow: 4,
      slidesToScroll: 1,
     infinite:false,
    watchCss:true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        }
      ]
    });
           setTimeout(function(){
        $('.thumb_main button.thumbnail')[0].click();
             }, 1);
      }
          function thumbImages(swatchAlt){
  $('.single-image-selected').unwrap();
   $('.product--thumbnail_cstm .thumbnail-list li').each(function(){
     var media_alt =$(this).attr('media-alt').toLowerCase().replace(/ /g, '').trim();
     // console.warn(swatchAlt+'/'+media_alt);
     if(media_alt==swatchAlt){
      $(this).show();
      $(this).addClass('single-image-selected');
      }
      else{
       $(this).hide();
      $(this).removeClass('single-image-selected');
      }
   });
   $('.single-image-selected').wrapAll('<div class="thumb_main"></div>');
   $('.thumb_main button.thumbnail')[0].click();         
    mainthumbslider();
}
     var swatchAlt= $('[name="Color"]:checked').val();
    if(swatchAlt != undefined){
   swatchAlt = swatchAlt.toLowerCase().replace(/ /g, '');  
  thumbImages(swatchAlt); 
  }
           $('body').on('click','.color__label',function(){
         var swatchAlt =$(this).attr('data-value');
        if(swatchAlt!=undefined){
          swatchAlt = swatchAlt.toLowerCase().replace(/ /g, '').trim();
           $('.thumb_main').slick('unslick');
          // $('.thumb_main').remove();
        thumbImages(swatchAlt);
        }
       })
           
          
        }
       else{
  $('.product--thumbnail_cstm .thumbnail-list').slick({
      dots: false,
      arrow: true,
      vertical: true,
      nextArrow: '<button type="button" class="slick-next"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
      prevArrow: '<button type="button" class="slick-prev"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path></svg></button>',
      slidesToShow: 4,
      slidesToScroll: 1,
     infinite:false,
    watchCss:true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        }
      ]
    });
  

      
    }
        
     }
   $('.product--thumbnail_cstm button.thumbnail').click(function(){
       var img= $(this).find('img').attr('src').split('&')[0];
       $('.desktop__slider img').attr('srcset',img);
      $('.desktop__slider img').attr('src',img);
  if($(window).width()<769){
     $('.product-media-modal__content img').attr('src',img);
    $('.product-media-modal__content img').attr('srcset',img);
  }
       })


   if($(window).width()<769){
     function thumbImagesmobile(swatchAlt){
     $('.thumbnail-slider .thumbnail-list.slider.slider--mobile li').each(function(){
     var media_alt =$(this).attr('media-alt').toLowerCase().replace(/ /g, '').trim();
     // console.warn(swatchAlt+'/'+media_alt);
     if(media_alt==swatchAlt){
      $(this).show();
      $(this).addClass('single-image-selected');
      }
      else{
       $(this).hide();
      $(this).removeClass('single-image-selected');
      }
   }).promise().done(function(){
        setTimeout(function(){
        $('.single-image-selected').eq(0).find('button').click();
             }, 1);
     })
     }
     
          var swatchAlt= $('[name="Color"]:checked').val();
    if(swatchAlt != undefined){
   swatchAlt = swatchAlt.toLowerCase().replace(/ /g, '');  
  thumbImagesmobile(swatchAlt); 
  }
           $('body').on('click','.color__label',function(){
         var swatchAlt =$(this).attr('data-value');
        if(swatchAlt!=undefined){
          swatchAlt = swatchAlt.toLowerCase().replace(/ /g, '').trim();
        thumbImagesmobile(swatchAlt);
        }
       })     
           }

      })